module.exports = __webpack_public_path__ + "img/89ne.c97180cc.svg";